import React from 'react';
import MielFleurs from '../../images/Miel3Fleurs.jpg';


const DiversContent = () => {
    return (
        <div className="category-content">
            <h3 className="content-title">Miel ADN41</h3>
            <div className="product-grid">
                <div className="product-item">
                    <h4>Miel  récolté dans le Vendomois</h4>
                    <p>Pot de 500grs</p>
                    
                    <img src={MielFleurs} alt="Miel de fleurs" className="product-image2" />
                </div>
                
            </div>
        </div>
    );
};

export default DiversContent;
